import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
        scroll-behavior: smooth;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #f7f9fc;
        overflow-x: hidden;
        color: #21324a;
    }

    a:hover {
        color: #1167ff;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: #f4f7fb;
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #1167ff 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #08265f;
        font-size: 52px;
        line-height: 1.08;
        letter-spacing: 0;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #3f526e;
        font-size: 19px;        
        line-height: 1.65;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #08265f;

        :hover {
            color: #1167ff;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
